import { useEffect } from 'react'

export const usePolling = (callback: () => void, delay: number, active: boolean) => {
  useEffect(() => {
    if (!active) return

    const intervalId = setInterval(callback, delay)
    return () => clearInterval(intervalId)
  }, [callback, delay, active])
}
